import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["filter", "activeFilterValue", "onSelect"],
    _excluded2 = ["groups", "indexedFilters", "onSelect", "activeFilterValue"],
    _excluded3 = ["indexedFilters", "activeFilterValue", "selected", "onSelected"],
    _excluded4 = ["addFilterLabel", "dismissLabel", "filters", "selected", "onSelected", "onDeselected", "groups", "renderSelected", "hideOnSelected", "portalContainer", "sheetCategoriesTitle", "sheetTitle", "sheetDoneTitle", "sheetCancelTitle", "popoverProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useEffect, useMemo, useState } from "react";
import FilterButton from "../FilterButton";
import { DropdownMenu } from "../Popover";
import FilterMenu, { Filters, HR, Item, OptionGroup, Options, OptionsRenderContainer, Search } from "../FilterMenu/FilterMenu";
import { FilterCategories, FiltersSheetTitle } from "../FilterMenu/SheetFilterMenu";
import { flattenChildren, indexBy, isFunction } from "../utils";
import Link from "../Link";
import Sheet, { SheetHeader } from "../Sheet";
import { withTheme } from "styled-components";
export var flattenOptions = function flattenOptions(options) {
  return options.reduce(function (acc, optGroup) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(optGroup.options));
  }, []);
};
export var isEnabled = function isEnabled(filter) {
  return !filter.disabled;
};
export var selectedLabel = function selectedLabel(filters, _ref) {
  var filter = _ref.filter,
      option = _ref.option;
  var selectedFilter = filters.filter(isEnabled).find(function (_ref2) {
    var value = _ref2.value;
    return value === filter;
  });

  if (!selectedFilter) {
    throw new Error("Unknown filter selected \"".concat(filter, "\""));
  }

  if (isFunction(selectedFilter.renderedOptionsDisplayValue)) {
    return selectedFilter.renderedOptionsDisplayValue(option.value);
  }

  return option.title;
};
export var optionValue = function optionValue(selected) {
  return selected ? selected.option ? selected.option.value : null : null;
};
export var filterValue = function filterValue(selected) {
  return selected ? selected.filter : null;
};
var indexByValue = indexBy(function (v) {
  return v.value;
});

var FilterItem = function FilterItem(_ref3) {
  var filter = _ref3.filter,
      activeFilterValue = _ref3.activeFilterValue,
      onSelect = _ref3.onSelect,
      props = _objectWithoutProperties(_ref3, _excluded);

  var cb = useCallback(function () {
    if (!filter.disabled) {
      onSelect(filter.value);
    }
  }, [onSelect, filter]);
  return /*#__PURE__*/React.createElement(Item, _extends({
    key: filter.value,
    onClick: cb,
    title: filter.title,
    selected: filter.value === activeFilterValue,
    disabled: filter.disabled
  }, props), filter.title);
};

export var GroupedFilters = function GroupedFilters(_ref4) {
  var groups = _ref4.groups,
      indexedFilters = _ref4.indexedFilters,
      onSelect = _ref4.onSelect,
      activeFilterValue = _ref4.activeFilterValue,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return /*#__PURE__*/React.createElement(Filters, props, groups ? flattenChildren(groups.map(function (values, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, values.map(function (value) {
      if (!indexedFilters[value]) {
        throw new Error("Cannot group unknown filter with value \"".concat(value, "\""));
      }

      return /*#__PURE__*/React.createElement(FilterItem, {
        key: value,
        filter: indexedFilters[value],
        activeFilterValue: activeFilterValue,
        onSelect: onSelect
      });
    }), i !== groups.length - 1 ? /*#__PURE__*/React.createElement(HR, {
      key: "hr".concat(i)
    }) : null);
  })) : Object.values(indexedFilters).map(function (filter) {
    return /*#__PURE__*/React.createElement(FilterItem, {
      filter: filter,
      activeFilterValue: activeFilterValue,
      onSelect: onSelect,
      key: filter.value
    });
  }));
};

var matchesQuery = function matchesQuery(query, optionText) {
  var normalizedQuery = query.toLowerCase();
  var normalizedText = optionText.toLowerCase();
  return normalizedText.includes(normalizedQuery);
};

export var FlatOptions = withTheme(function (_ref5) {
  var options = _ref5.options,
      selected = _ref5.selected,
      onSelected = _ref5.onSelected,
      enableSearch = _ref5.enableSearch,
      searchHidden = _ref5.searchHidden,
      onSearchChange = _ref5.onSearchChange,
      searchPlaceholder = _ref5.searchPlaceholder,
      searchValue = _ref5.searchValue,
      _ref5$inOptionGroup = _ref5.inOptionGroup,
      inOptionGroup = _ref5$inOptionGroup === void 0 ? false : _ref5$inOptionGroup;
  var containsSelected = inOptionGroup || options.some(function (d) {
    return d.value === optionValue(selected);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!enableSearch && !searchHidden && !!onSearchChange && /*#__PURE__*/React.createElement(Search, {
    placeholder: searchPlaceholder || "Search",
    onChange: onSearchChange,
    value: searchValue
  }), options.filter(function (option) {
    return !enableSearch || searchValue === "" || matchesQuery(searchValue, option.title);
  }).map(function (option, index) {
    return /*#__PURE__*/React.createElement(Item, {
      title: option.title,
      onClick: function onClick() {
        return onSelected(option);
      },
      key: option.value,
      disabled: option.disabled,
      selected: containsSelected ? optionValue(selected) ? option.value === optionValue(selected) : false : undefined
    }, option.title);
  }));
});
export var FilterOptions = function FilterOptions(_ref6) {
  var indexedFilters = _ref6.indexedFilters,
      activeFilterValue = _ref6.activeFilterValue,
      selected = _ref6.selected,
      _onSelected = _ref6.onSelected,
      props = _objectWithoutProperties(_ref6, _excluded3);

  var selectedFilter = indexedFilters[activeFilterValue || filterValue(selected)];
  var optionsRender = selectedFilter.optionsRender,
      options = selectedFilter.options;
  var componentOnSelectedCallback = useCallback(function (option) {
    _onSelected(option, selectedFilter.value);
  }, [selectedFilter, _onSelected]);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      _setQuery = _useState2[1];

  var onSearch = useCallback(function (e) {
    _setQuery(function (s) {
      return _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, selectedFilter.value, e.target.value));
    });
  }, [selectedFilter.value, _setQuery]);
  return optionsRender ? /*#__PURE__*/React.createElement(OptionsRenderContainer, null, optionsRender({
    onSelected: componentOnSelectedCallback,
    selected: selected ? selected.option : null
  })) : options ? /*#__PURE__*/React.createElement(Options, props, options[0] && options[0].options ? [].concat(_toConsumableArray(selectedFilter.enableSearch ? [/*#__PURE__*/React.createElement(Search, {
    key: "__search",
    value: query[selectedFilter.value] || "",
    placeholder: selectedFilter.searchPlaceholder || "Search",
    onChange: onSearch
  })] : []), _toConsumableArray(options.filter(function (optionGroup) {
    var searchQuery = query[selectedFilter.value] || "";
    return !selectedFilter.enableSearch || optionGroup.options.filter(function (option) {
      return searchQuery === "" || matchesQuery(searchQuery, option.title);
    }).length > 0;
  }).map(function (optionGroup, i) {
    return /*#__PURE__*/React.createElement(OptionGroup, {
      title: optionGroup.title,
      key: optionGroup.value,
      selected: optionGroup.options.some(function (option) {
        return option.value === optionValue(selected);
      })
    }, /*#__PURE__*/React.createElement(FlatOptions, {
      enableSearch: selectedFilter.enableSearch,
      searchHidden: true,
      searchPlaceholder: selectedFilter.searchPlaceholder || "Search",
      searchValue: query[selectedFilter.value] || "",
      onSearchChange: onSearch,
      selected: selected,
      inOptionGroup: true,
      options: optionGroup.options,
      onSelected: function onSelected(option) {
        return _onSelected(option, activeFilterValue);
      }
    }));
  }))) : /*#__PURE__*/React.createElement(FlatOptions, {
    enableSearch: selectedFilter.enableSearch,
    searchPlaceholder: selectedFilter.searchPlaceholder || "Search",
    searchValue: query[selectedFilter.value] || "",
    onSearchChange: onSearch,
    selected: selected,
    options: options,
    onSelected: function onSelected(option) {
      return _onSelected(option, activeFilterValue);
    }
  })) : null;
};

var firstEnabledFilter = function firstEnabledFilter(filters) {
  var found = filters.find(isEnabled);

  if (!found) {
    throw new Error("Provide at least one enabled filter");
  }

  return found;
};

export default (function (_ref7) {
  var addFilterLabel = _ref7.addFilterLabel,
      dismissLabel = _ref7.dismissLabel,
      _filters = _ref7.filters,
      selectedProp = _ref7.selected,
      _ref7$onSelected = _ref7.onSelected,
      _onSelected2 = _ref7$onSelected === void 0 ? function () {} : _ref7$onSelected,
      _ref7$onDeselected = _ref7.onDeselected,
      onDeselected = _ref7$onDeselected === void 0 ? function () {} : _ref7$onDeselected,
      _ref7$groups = _ref7.groups,
      groups = _ref7$groups === void 0 ? null : _ref7$groups,
      _ref7$renderSelected = _ref7.renderSelected,
      renderSelected = _ref7$renderSelected === void 0 ? selectedLabel : _ref7$renderSelected,
      _ref7$hideOnSelected = _ref7.hideOnSelected,
      hideOnSelected = _ref7$hideOnSelected === void 0 ? false : _ref7$hideOnSelected,
      portalContainer = _ref7.portalContainer,
      _ref7$sheetCategories = _ref7.sheetCategoriesTitle,
      sheetCategoriesTitle = _ref7$sheetCategories === void 0 ? "Category" : _ref7$sheetCategories,
      _ref7$sheetTitle = _ref7.sheetTitle,
      sheetTitle = _ref7$sheetTitle === void 0 ? "Filter" : _ref7$sheetTitle,
      _ref7$sheetDoneTitle = _ref7.sheetDoneTitle,
      sheetDoneTitle = _ref7$sheetDoneTitle === void 0 ? "Done" : _ref7$sheetDoneTitle,
      _ref7$sheetCancelTitl = _ref7.sheetCancelTitle,
      sheetCancelTitle = _ref7$sheetCancelTitl === void 0 ? "Cancel" : _ref7$sheetCancelTitl,
      _ref7$popoverProps = _ref7.popoverProps,
      popoverProps = _ref7$popoverProps === void 0 ? {} : _ref7$popoverProps,
      buttonProps = _objectWithoutProperties(_ref7, _excluded4);

  var _selected = useMemo(function () {
    if (selectedProp) {
      var selectedFilter = indexByValue(_filters)[selectedProp.filter];

      if (selectedFilter.optionsRender) {
        return {
          filter: selectedFilter.value,
          option: {
            value: selectedProp.value,
            title: isFunction(selectedFilter.renderedOptionsDisplayValue) ? selectedFilter.renderedOptionsDisplayValue(selectedProp.value) : selectedProp.value
          }
        };
      }

      if (selectedProp.value) {
        var selectedOptions = selectedFilter.options[0].options ? flattenOptions(selectedFilter.options) : selectedFilter.options;
        var selectedOption = selectedOptions.find(function (_ref8) {
          var value = _ref8.value;
          return value === selectedProp.value;
        });

        if (!selectedOption) {
          console.error("Unknown option selected for ".concat(selectedProp.filter, ": ").concat(selectedProp.value)); // stub out the selectedOption with just the value we have to keep the application alive

          selectedOption = {
            title: selectedProp.value,
            value: selectedProp.value
          };
        }

        return {
          filter: selectedFilter.value,
          option: {
            value: selectedOption.value,
            title: selectedOption.title
          }
        };
      }

      return {
        filter: selectedFilter.value
      };
    }
  }, [_filters, selectedProp]);

  var _useState3 = useState(_selected ? _selected.filter : firstEnabledFilter(_filters).value),
      _useState4 = _slicedToArray(_useState3, 2),
      activeFilterValue = _useState4[0],
      setActiveFilter = _useState4[1];

  var _useState5 = useState(_selected || null),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      draft = _useState8[0],
      setDraft = _useState8[1];

  var _useState9 = useState(_filters),
      _useState10 = _slicedToArray(_useState9, 2),
      filters = _useState10[0],
      setFilters = _useState10[1];

  var indexedFilters = indexByValue(filters);
  var groupsFlattened = groups ? groups.flat() : [];
  var sortedFilters = groupsFlattened ? filters.sort(function (a, b) {
    return groupsFlattened.indexOf(a.value) - groupsFlattened.indexOf(b.value);
  }) : filters;

  var clear = function clear() {
    setSelected(null);
    setActiveFilter(filters[0].value);
  };

  var setActiveFilterCallback = useCallback(function (selected, filters) {
    setActiveFilter(selected ? selected.filter : firstEnabledFilter(filters).value);
  }, [setActiveFilter]);
  var resetActiveFilterCallback = useCallback(function () {
    setActiveFilterCallback(selected, filters);
  }, [setActiveFilterCallback, filters, selected]);
  useEffect(function () {
    setActiveFilterCallback(_selected, _filters);
    setFilters(_filters);
    setSelected(_selected);
  }, [setActiveFilterCallback, _selected, _filters]);

  var _ref13 = /*#__PURE__*/React.createElement(FiltersSheetTitle, null, sheetTitle);

  return /*#__PURE__*/React.createElement(Sheet, {
    PopoverComponent: DropdownMenu,
    popoverProps: _objectSpread({
      portalContainer: portalContainer
    }, popoverProps),
    smAppearanceMode: "SlideUp",
    onSheetOpened: function onSheetOpened() {
      // in the sheet we don't "apply" the new selected state until the user
      // clicks the done button, to mirror the functionality of the visually
      // similar native iOS UI.
      setDraft(selected);
    },
    onPopoverClosed: resetActiveFilterCallback,
    onSheetClosed: resetActiveFilterCallback,
    smHeader: function smHeader() {
      return /*#__PURE__*/React.createElement(SheetHeader, {
        leftButton: function leftButton(_ref9) {
          var hide = _ref9.hide,
              focusableRef = _ref9.focusableRef;
          return /*#__PURE__*/React.createElement(Link, {
            as: "button",
            tabIndex: "0",
            textAlign: "center",
            textStyle: "bodyViewSRegular",
            ref: focusableRef,
            color: "ctrl",
            onClick: function onClick(e) {
              e.preventDefault();
              setSelected(draft);
              hide();
            }
          }, sheetCancelTitle);
        },
        rightButton: function rightButton(_ref10) {
          var hide = _ref10.hide;
          return /*#__PURE__*/React.createElement(Link, {
            as: "button",
            tabIndex: "0",
            textAlign: "center",
            textStyle: "bodyViewSMedium",
            color: selected ? "ctrl" : "ctrlDisabled",
            disabled: !selected,
            onClick: function onClick(e) {
              e.preventDefault();
              onDeselected(draft);

              _onSelected2(selected);

              hide();
            }
          }, sheetDoneTitle);
        }
      });
    },
    target: function target(_ref11) {
      var targetProps = _ref11.targetProps,
          ref = _ref11.ref,
          setHidden = _ref11.setHidden,
          isHidden = _ref11.isHidden;
      return /*#__PURE__*/React.createElement(FilterButton, _extends({
        ref: ref,
        onClick: function onClick() {
          setHidden(!isHidden);
        },
        dismissProps: {
          "aria-label": dismissLabel
        },
        dismissable: !!optionValue(selected),
        hasDownArrow: !!optionValue(selected),
        onDismiss: function onDismiss() {
          onDeselected(selected);
          clear();

          _onSelected2(null);
        }
      }, targetProps, buttonProps), optionValue(selected) ? renderSelected(filters, selected) : addFilterLabel);
    },
    content: function content(_ref12) {
      var hide = _ref12.hide;
      return function () {
        return /*#__PURE__*/React.createElement(FilterMenu, null, /*#__PURE__*/React.createElement(GroupedFilters, {
          groups: groups,
          indexedFilters: indexedFilters,
          activeFilterValue: activeFilterValue,
          onSelect: function onSelect(filterValue) {
            return setActiveFilter(filterValue);
          }
        }), /*#__PURE__*/React.createElement(FilterOptions, {
          indexedFilters: indexedFilters,
          activeFilterValue: activeFilterValue,
          selected: selected,
          onSelected: function onSelected(option, filterValue) {
            var newSelection = {
              filter: filterValue,
              option: option
            };
            setSelected(newSelection);
            onDeselected(selected);

            _onSelected2(newSelection);

            if (hideOnSelected) {
              hide();
            }
          }
        }));
      };
    },
    smContent: function smContent() {
      return /*#__PURE__*/React.createElement(FilterMenu, {
        variant: "mobile"
      }, _ref13, /*#__PURE__*/React.createElement(FilterCategories, {
        title: sheetCategoriesTitle,
        filters: sortedFilters,
        selectedValue: activeFilterValue,
        onSelect: function onSelect(filterValue) {
          setActiveFilter(filterValue);
        }
      }), /*#__PURE__*/React.createElement(FilterOptions, {
        indexedFilters: indexedFilters,
        activeFilterValue: activeFilterValue,
        selected: selected,
        onSelected: function onSelected(option, filterValue) {
          var newSelection = {
            filter: filterValue,
            option: option
          };
          setSelected(newSelection);
        }
      }));
    }
  });
});